import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/button',
  //   component: () => import('@/views/promotion/button')
  // },
  {
    path: '/modules',
    component: () => import('@/views/promotion')
  },
  {
    path: '/tjbnb/front/promotion/cms',
    component: () => import('@/views/promotion')
  },
  {
    path: '/tjpromotion',
    component: () => import('@/views/promotion')
  },
  {
    path: '/qunarerror',
    component: () => import('@/views/qunarerror')
  },
  {
    path: '/modules/defaulterror',
    component: () => import('@/views/defaulterror')
  },
  {
    path: '/healthcheck',
    component: () => import('@/views/default')
  }
]

export default new VueRouter({
  mode: 'history',
  routes
})
